<template>

  <div class="container px-0 px-sm-1 px-md-2">
    <div class="row mt-4 mb-0 mb-xs-3" v-if="!signInMode &&!creationInProgress">
      <div class="col">
      </div>

      <div class="col-auto">

        <div class="d-none d-sm-flex container px-0 mt-0 mx-0 mb-5" style="max-width: 700px">

          <div class="row">
            <div class="col payment-step p-0 m-0 ">
              <div class="payment-step-number">1</div>
              <div class="payment-step-text">Select <br>a Plan</div>
            </div>

            <div class="col pt-4"> <div class="payment-step-between "> </div> </div>

            <div class="col payment-step payment-active  p-0 m-0">
                <div class="payment-step-number" style="background-color: #1973A0; color: #AAE3FF; font-weight: bold; box-shadow: 0px 0px 10.2px 0px rgba(109,189,229,0.8); border-color: #AAE3FF;">2</div>
                <div class="payment-step-text" style="color: #AAE3FF; font-weight: bold">Create <br>an Account</div>
            </div>

            <div class="col pt-4"> <div class="payment-step-between "> </div> </div>

            <div class="col payment-step payment-active  p-0 m-0" style="opacity: 0.5;">
              <div class="payment-step-number">3</div>
              <div class="payment-step-text">Choose Payment<br> Method</div>
           </div>

            <div class="col pt-4"> <div class="payment-step-between "> </div> </div>

            <div class="col payment-step payment-active  p-0 m-0" style="opacity: 0.5;">
              <div class="payment-step-number">4</div>
              <div class="payment-step-text">Confirm<br> Payment</div>
            </div>
          </div>
        </div>

        <div class="d-sm-none container px-0 m-0" style="max-width: 700px; transform: scale(0.9);">

          <div class="row">
            <div class="col payment-step p-0 m-0 ">
              <div class="payment-step-number">1</div>
              <div class="payment-step-text">Select <br>a Plan</div>
            </div>

            <div class="col payment-step payment-active  p-0 m-0">
              <div class="payment-step-number" style="background-color: #1973A0; color: #AAE3FF; font-weight: bold; box-shadow: 0px 0px 10.2px 0px rgba(109,189,229,0.8); border-color: #AAE3FF;">2</div>
              <div class="payment-step-text" style="color: #AAE3FF; font-weight: bold">Create <br>an Account</div>
            </div>

            <div class="col payment-step payment-active  p-0 m-0" style="opacity: 0.5;">
              <div class="payment-step-number">3</div>
              <div class="payment-step-text">Choose Payment<br> Method</div>
            </div>


            <div class="col payment-step payment-active  p-0 m-0" style="opacity: 0.5;">
              <div class="payment-step-number">4</div>
              <div class="payment-step-text">Confirm<br> Payment</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col">
      </div>

    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-md-7 mt-0 pt-0 glass-border-enhanced" style="position: relative; z-index: 100">
        <div id="card-login-forgot" class="card card-shadow " style="border-bottom: 0; border-radius: 25px; margin-top:20px!important;">
          <div class="card-login-forgot-inner" >
            <div class="f-wrapper pb-0">
              <!-- only for mobile -> first screen -->
              <div v-if="checkIsCordova && welcomeMode">
                <MobileWelcomeScreen
                    @update-welcome-mode = "switchFromWelcomeMode"
                ></MobileWelcomeScreen>
              </div>

              <!--log in-->
              <div v-else-if="signInMode && !creationInProgress">
                <SingInForm @signupInProgress="trackCreation" ref="signIn"></SingInForm>
              </div>

              <!-- create an account -->
              <div v-else-if="!creationInProgress">
                <SingUpForm  @signupInProgress="trackCreation" ref="signUp"></SingUpForm>
              </div>

              <!-- creation in porgress -->

              <div v-else>
                <SignUpInProgress ref="signUpInProgress"></SignUpInProgress>
              </div>


            </div>


            <div  v-if="!welcomeMode && !creationInProgress" class="container bottom-container" style="border-radius:0 0 20px 20px; padding-top: 5px; padding-bottom: 5px;">
              <div v-if="!organizationInfo && loading === false && !creationInProgress" class="row">

                <div class="col-12 text-center d-flex justify-content-center align-items-center">

                  <p class="m-0 d-none d-sm-inline" style="font-weight: bold" v-if="signInMode">{{$tr('signin.nothave-account','Do not have an account yet?')}}</p>
                  <p class="m-0" style="font-weight: bold" v-else>{{$tr('signin.have-account','Already have an account?')}}</p>

                  <p class="m-0 d-sm-none" style="font-weight: bold" v-if="signInMode">{{$tr('signin.nothave-account-sm','No account yet?')}}</p>


                  <button v-if="signInMode" data-test-path="signin-btn-goto-signup" @click="switchMode()"
                          class="switch-mode-btn ml-3 text-primary border-primary">
                    <span class="d-none d-sm-inline">{{$tr('signin.go-signup','Go to Sign Up')}}</span>
                    <span class="d-sm-none">{{$tr('signin.go-signup-sm','Sign Up!')}}</span>

                  </button>
                  <div @click="switchMode()" v-else class="ml-3 text-primary text-decoration-underline" style="cursor: pointer">
                    <span>{{$tr('signin.go-signin','Go to Sign In')}}</span>
                  </div>
                </div>

              </div>

              <div v-if="organizationInfo && organizationInfo.urlLoginPageImage && organizationInfo.urlLoginPageImage.url && loading === false && !creationInProgress" class="row">
                <div class="col-12 organization-image">
                  <img v-if="organizationInfo.urlLoginPageImage.url" class="img-fluid" :src="organizationInfo.urlLoginPageImage.url" alt="">
                  <h4 v-else class="organization-name mb-0">{{organizationInfo.name}}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div :class="['miniimage', 'miniimage1', miniImage1Visible ? 'show' : 'hide']"></div>
    <div :class="['miniimage', 'miniimage2', miniImage2Visible ? 'show' : 'hide']"></div>
    <div :class="['miniimage', 'miniimage3', miniImage3Visible ? 'show' : 'hide']"></div>
    <div :class="['miniimage', 'miniimage4', miniImage1Visible ? 'show' : 'hide']"></div>
    <div :class="['miniimage', 'miniimage5', miniImage2Visible ? 'show' : 'hide']"></div>
    <div :class="['miniimage', 'miniimage6', miniImage3Visible ? 'show' : 'hide']"></div>
    <div style="position: absolute; left: 5px; bottom: 5px; font-size: 8pt; color: #44a49f">{{currentRegion}}</div>
  </div>


</template>

<script>
import Rpc from '@/Rpc';
import SingInForm from "@/components/SignInForm";
import SingUpForm from "@/components/SignUpForm";
import MobileWelcomeScreen from "@/components/MobileWelcomeScreen.vue"
import {hasPendingInvite} from "@/invitations/invites";
import {
  currentRegion,
  getAvailableUserConnections,
  getPreselectedPlan,
  switchServer
} from "@/components/subscriptions/Subs";
import FormHeader from "@/components/forms/FormHeader.vue";
import FormLink from "@/components/dashlets/FormLink.vue";
import DialogManager from "@/utils/DialogManager";
import SignUpInProgress from "@/components/SignUpInProgress.vue";



export default {
  components: {SignUpInProgress, FormLink, FormHeader, SingUpForm, SingInForm, MobileWelcomeScreen },
  computed: {
    checkIsCordova() {
      return window.isCordova;
    },
  },
  created: function () {
    if(this.creationInProgress){
      this.trackCreation();
    }

    if (this.checkIsCordova && window.localStorage.getItem('welcomeModeState') === null) {
      this.welcomeMode = true;
    } else if (this.checkIsCordova && window.localStorage.getItem('welcomeModeState') !== null) {
      let regexPattern = new RegExp("true");
      this.welcomeMode = regexPattern.test(window.localStorage.getItem('welcomeModeState'));
    }

    this.$onEvent(Events.googleSignIn, async (loginData)=>{
      let orgsData = await getAvailableUserConnections(loginData.email);

      if(orgsData['server_name']){
        this.signInMode = true;
        this.$nextTick(() => {
          switchServer(orgsData['server_name']);
          try {
            this.$refs.signIn.signInWithGoogleId(loginData, []);
          }
          catch(e){
            Log.fatal("signInWithGoogleId failed: " + loginData.email);
            DialogManager.errorNotification($tr('sso-registration-failed', "Registration failed, please contact support"));
          }
        });
        return;

      } else {
        let orgs = orgsData.organizations;
        if (orgs.length >= 1) {
          this.signInMode = true;
          this.$nextTick(() => {
            try {
              this.$refs.signIn.signInWithGoogleId(loginData, orgs);
            }
            catch(e){
              Log.fatal("signInWithGoogleId failed: " + loginData.email);
              DialogManager.errorNotification($tr('sso-registration-failed', "Registration failed, please contact support"));
            }
          });
          return;
        }
      }

      this.signInMode = false;
      this.$nextTick(() => {
        this.$refs.signUp.signUpWithGoogleId(loginData);
      });
      return
    })
  },
  data: () => ({
    currentRegion: currentRegion(),
    mode: "signIn",
    signInMode: !(getPreselectedPlan() || hasPendingInvite()),
    creationInProgress: SessionManager?.organizationSetupProgress && SessionManager?.organizationSetupProgress !== "complete",
    welcomeMode: false,
    loading: true,
    organizationInfo: null,
    alwaysPassingToken: "",
    miniImage1Visible: true,
    hasInvitation: hasPendingInvite(),
    miniImage2Visible: false,
    miniImage3Visible: false,
    miniImage4Visible: false,
    intervalId: null,
  }),
  methods: {
    trackCreation(){
      this.creationInProgress = true;
    },
    switchMode() {
      if(this.signInMode){
        if(!(window.location.href.includes("localhost") || this.hasPreselectedPlan || this.hasInvitation || this.hasAutoconf || window['__signup'])){
          window.location.replace("/designer-plan/");
          return;
        }
      }
      this.signInMode = !this.signInMode;
    },
    switchFromWelcomeMode(val) {
      if (val === "signUp") {
        this.switchMode();
        this.welcomeMode = false;
      } else {
        this.welcomeMode = false;
      }
      window.localStorage.setItem('welcomeModeState', this.welcomeMode);
    },
    async extractDomainName() {
      let domain = window.location.hostname;
      this.organizationInfo = await Rpc.Session.extractOrganizationFromDomain(domain);
      this.loading = false;
    },
    toggleMiniImages() {
      if (this.miniImage1Visible) {
        this.miniImage1Visible = false;
        this.miniImage2Visible = true;
      } else if (this.miniImage2Visible) {
        this.miniImage2Visible = false;
        this.miniImage3Visible = true;
      } else if (this.miniImage3Visible) {
        this.miniImage3Visible = false;
        this.miniImage1Visible = true;
      }
    },
  },
  async mounted() {
    await this.extractDomainName();
    this.intervalId = setInterval(this.toggleMiniImages, 3000);
    this.$onEvent(Events.endpointUpdated, () => {
      this.currentRegion = currentRegion();
    });
    if(this.creationInProgress){
      this.trackCreation();
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  name: "SignIn"

}

</script>


<style lang="sass">

  @import "../styles/card.sass"
  @import "../styles/login-forgot"

  .switch-mode-btn
    background: transparent
    border: 1px solid black
    font-weight: bold
    border-radius: 25px
    padding: 5px 15px


</style>

